import { render } from "./AgentAddEdit.vue?vue&type=template&id=3c9fbe4c&scoped=true"
import script from "./AgentAddEdit.vue?vue&type=script&lang=js"
export * from "./AgentAddEdit.vue?vue&type=script&lang=js"

import "./AgentAddEdit.vue?vue&type=style&index=0&id=3c9fbe4c&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9fbe4c"]])

export default __exports__